module.exports = __webpack_public_path__ + "img/17_22.14121ce6.png";